import baseControllerInput from './baseControllerInput'
import { REQUIRED_ERROR_MESSAGE } from 'messages'

const REGEX = [/\d/, /\d/, /\d/]

export default baseControllerInput({
  getErrorMessage: state => {
    const value = state.input.value
    const intValue = parseInt(value, 10)
    return value.length >= 2 && intValue > 0 ? '' : REQUIRED_ERROR_MESSAGE
  },
  maskConfig: {
    mask: REGEX,
    guide: false
  }
})
